import React, { useState, useRef, useEffect } from "react";
import BundleDefault from "assets/icons/A4.svg";
import {
  HeartOutlined,
  ShareAltOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { patchFavoriteBundle, patchUnfavoriteBundle } from "api/bundle";
import ShareModal from "./BundleShare";
import { Button, Rate } from "antd";
import styles from "./Card.module.scss";
import { FaHeart } from "react-icons/fa";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import _ from "lodash";
import useAuth from "../../../../context/auth";

const Card = ({ bundleItem, i, handleClickCard, refetch }) => {
  const [isHome, setIsHome] = useState(false);
  const [visibleHover, setVisibleHover] = useState(false);
  const [displayShareModal, setDisplayShareModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const history = useHistory();
  const {
    state: { user },
  } = useAuth();

  const preventClickRef = useRef(false);

  useEffect(() => {
    setIsHome(_.includes(["/", ""], history.location.pathname));
  }, []);

  const onClickLike = async (id) => {
    if (user) {
      setIsLoading(true);
      preventClickRef.current = true;
      if (bundleItem.isFavorite) {
        await patchUnfavoriteBundle({ id: bundleItem.id });
      } else {
        await patchFavoriteBundle({ id: bundleItem.id });
      }
      refetch();
      setIsLoading(false);
    } else {
      preventClickRef.current = true;
      history.push("/login");
    }
  };

  const openShareModal = () => {
    setDisplayShareModal(true);
  };

  const closeShareModal = () => {
    setDisplayShareModal(false);
  };

  const onClickShare = (event) => {
    preventClickRef.current = true;
    event.stopPropagation();
    setDisplayShareModal((prev) => !prev);
  };

  const handleCardClick = () => {
    if (preventClickRef.current) {
      preventClickRef.current = false;
      return;
    }
    handleClickCard(bundleItem.id);
  };

  const bundleCardBannerHoverStyleHome = {
    position: "absolute",
    marginTop: "142px",
    background:
      "linear-gradient(0deg, rgba(143, 143, 143, 1) 0%, rgba(255, 255, 255, 0) 100%)",
    padding: "50px 1rem 25px 1rem",
    borderRadius: "0.5rem",
    display: "flex",
    justifyContent: "space-around",
    width: "230px",
  };

  const bundleCardBannerHoverStyleDetail = {
    position: "absolute",
    marginTop: "83px",
    background:
      "linear-gradient(0deg, rgba(143, 143, 143, 1) 0%, rgba(255, 255, 255, 0) 100%)",
    padding: "50px 1rem 25px 1rem",
    borderRadius: "0.5rem",
    display: "flex",
    justifyContent: "space-around",
    width: "157px",
  };

  const iconStyleHome = {
    fontSize: "20px",
    transition: "color 0.3s ease",
    color: "#ee5294",
  };

  const bundleNameHome = {
    width: "140px",
    height: "40px",
  };

  const bundleNameDetail = {
    width: "150px",
    height: "40px",
  };

  return (
    <div
      className={styles.bundle_card}
      key={i}
      onClick={handleCardClick}
      style={
        history.location.pathname === "/"
          ? { width: "230px" }
          : { maxWidth: "230px", width: "100%" }
      }
    >
      <div
        className={styles.bundle_card_banner}
        onMouseEnter={() => setVisibleHover(true)}
        onMouseLeave={() => setVisibleHover(false)}
        style={isHome ? {} : { margin: "0 0.5rem 0 0.5rem" }}
      >
        {visibleHover &&
          !_.some(
            ["bundle", "myExam", "myFavorite", "subject", "publisher"],
            (path) => _.includes(history.location.pathname.split("/")[1], path)
          ) && (
            <div
              style={
                isHome
                  ? bundleCardBannerHoverStyleHome
                  : bundleCardBannerHoverStyleDetail
              }
            >
              {isLoading ? (
                <LoadingOutlined />
              ) : bundleItem.isFavorite ? (
                <FaHeart
                  onClick={onClickLike}
                  style={iconStyleHome}
                  onMouseEnter={(e) => (e.target.style.color = "#ee5294")}
                  onMouseLeave={(e) => (e.target.style.color = "inherit")}
                />
              ) : (
                <HeartOutlined className={styles.icon} onClick={onClickLike} />
              )}
              <ShareAltOutlined
                className={styles.icon}
                onClick={onClickShare}
              />
            </div>
          )}
        <div
          className={styles.bundle_banner}
          style={isHome ? { width: "140px" } : { width: "100px" }}
        >
          {!bundleItem.banner ? (
            <img
              src={bundleItem.cover}
              alt={bundleItem.name}
              className={styles.bundle_card_banner_img}
            />
          ) : (
            <img
              src={BundleDefault}
              alt="default"
              className={styles.bundle_card_banner_img}
            />
          )}
        </div>
      </div>
      <div
        className={styles.detail}
        style={isHome ? {} : { margin: "0 0.5rem 0 0.5rem" }}
      >
        <div className={styles.bundle_card_detail}>
          <div
            className={styles.bundle_card_detail_publisher}
            style={{ width: "150px", height: "20px" }}
          >
            {bundleItem.publisher}
          </div>
        </div>
        <div
          className={styles.bundle_name}
          style={isHome ? bundleNameHome : bundleNameDetail}
        >
          {bundleItem.name}
        </div>
        <div className={styles.bundle_card_detail_rating}>
          <Rate
            value={bundleItem.review.reviewPoint}
            allowHalf
            disabled
            style={{ fontSize: ".75rem", marginLeft: "0.5rem" }}
          />
        </div>
        <div className={styles.bundle_card_button}>
          <Button
            type="primary"
            className={styles.bundle_card_button_buy}
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            {bundleItem.isPurchase ? "เริ่มทำข้อสอบ" : `฿ ${bundleItem.price}`}
          </Button>
        </div>
      </div>
      <ShareModal
        displayShareModal={displayShareModal}
        openShareModal={openShareModal}
        closeShareModal={closeShareModal}
        url={bundleItem.linkBundle}
      />
    </div>
  );
};

export default Card;
